import React from 'react'
import DocumentTitle from 'react-document-title'
import PageHero from "../components/PageHero"
import PageHeroContentSection from "../components/PageHeroContentSection"
import { getPageTitle } from "../utility/utility"
import './Developer.scss'
import twoTreesLogo from '../images/logo-two-line.jpg'

export default class DeveloperPage extends React.Component {
  static pageTitle(listings, routeParams) { // eslint-disable-line no-unused-vars
    return '300 Ashland Pl: Two Trees Apartments in Fort Greene Brooklyn';
  }

  render() {
    return (
      <DocumentTitle title={getPageTitle(this.constructor, this.props)}>
        <div className='content' id="main" role="main">
          <PageHero heading="The Developer" noContentBelow>
            <PageHeroContentSection>
              <img src={twoTreesLogo} className='logo' alt="Two Trees" />
              <h2 className="logo-text">Two Trees</h2>
              <p>Two Trees is a family-owned, Brooklyn-based real estate developer best known for our singular role in transforming the Brooklyn neighborhood of DUMBO from a neglected industrial waterfront to a thriving mixed-use community. Our fundamental belief is that successful neighborhoods offer a wide variety of uses and attract diverse groups of people. Developers must play a fundamental role in cultivating livable streetscapes because people prosper when neighborhoods bloom. In addition to residential and commercial buildings in DUMBO, Williamsburg, Fort Greene, Brooklyn Heights, Hell’s Kitchen and the Flatiron neighborhoods, Two Trees’ other notable projects include Domino Park, The Refinery at Domino, River Ring, The Wythe Hotel and Jane’s Carousel.</p>
              <a href='https://www.twotreesny.com/about-us' target='_blank'>
                Learn More About Two Trees
              </a>
            </PageHeroContentSection>
          </PageHero>
        </div>
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/Developer.js